import { calculateBlameOffset } from '../utils';
import { BLAME_AGE_COLORS, BLAME_COLUMN_DEFAULT_WIDTH } from '../constants';
import BlameCommitInfo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/blob/components/source_viewer/components/blame_commit_info.vue?vue3';
import BlameColumnResizer from './blame_column_resizer.vue';
export default {
    name: 'BlameInfo',
    BLAME_AGE_COLORS,
    components: {
        BlameCommitInfo,
        BlameColumnResizer
    },
    props: {
        blameInfo: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            containerHeight: 0,
            containerWidth: BLAME_COLUMN_DEFAULT_WIDTH
        };
    },
    computed: {
        processedBlameInfo () {
            return this.blameInfo.map((blame, index)=>{
                const ageClass = blame.commitData?.ageMapClass ?? '';
                const indicatorColor = this.$options.BLAME_AGE_COLORS[ageClass] || 'transparent';
                const height = this.calculateCommitHeight(blame, this.blameInfo[index + 1]);
                return {
                    ...blame,
                    style: {
                        '--blame-indicator-top': blame.blameOffset,
                        '--blame-indicator-color': indicatorColor,
                        '--blame-indicator-height': `${height}px`
                    }
                };
            });
        }
    },
    watch: {
        blameInfo: {
            handler () {
                this.$nextTick(()=>{
                    this.updateContainerHeight();
                });
            },
            deep: true
        }
    },
    mounted () {
        this.updateContainerHeight();
    },
    methods: {
        calculateCommitHeight (commitInfo, nextCommitInfo) {
            const currentOffset = parseInt(commitInfo.blameOffset, 10) || 0;
            const { lineno, span } = commitInfo;
            // Bound the indicator to this group's range. If its end line is in an
            // unloaded chunk, render nothing rather than spanning across the gap.
            if (span) {
                const groupEndOffset = calculateBlameOffset(lineno + span);
                if (groupEndOffset === null) return 0;
                return Math.max(parseInt(groupEndOffset, 10) - currentOffset, 0);
            }
            if (!nextCommitInfo) return this.containerHeight - currentOffset;
            const nextOffset = parseInt(nextCommitInfo.blameOffset, 10) || 0;
            return Math.max(nextOffset - currentOffset, 0);
        },
        updateContainerHeight () {
            if (this.$el) {
                this.containerHeight = this.$el.offsetHeight;
            }
        }
    }
};
